import { USER } from "@/data/user";
import type { NavItem } from "@/types/nav";

export const SITE_INFO = {
  name: USER.displayName,
  url: process.env.APP_URL || "https://adarxh.me",
  ogImage: USER.ogImage,
  description: USER.bio,
  keywords: USER.keywords,
};

export const META_THEME_COLORS = {
  light: "#f5effb", // Our new light theme background color
  dark: "#09090b", // Keeping dark theme color the same
};

export const MAIN_NAV: NavItem[] = [
  {
    title: "Adarxh",
    href: "/",
  },
];

export const SOURCE_CODE_GITHUB_REPO = "iaadarsh23/Adarxh.me";
export const SOURCE_CODE_GITHUB_URL = "https://github.com/iaadarsh23/Adarxh.me";
export const PROFILE_GITHUB_URL = "https://github.com/iaadarsh23";

export const UTM_PARAMS = {
  utm_source: "adarxh.me",
  utm_medium: "portfolio_website",
  utm_campaign: "referral",
};
